import { AppLayout } from "@/components/AppLayout";
import { PageHeader } from "@/components/ui/page-header";

export default function PrivacyPolicy() {
  return (
    <AppLayout>
      <PageHeader 
        title="Privacy Policy" 
        description="How we collect, use, and protect your personal information"
        backTo="/"
      />
      <div className="container mx-auto max-w-4xl px-4 py-12">
        <div className="prose prose-lg max-w-none dark:prose-invert">
          <p className="text-muted-foreground text-center mb-12">
            <strong>Effective Date:</strong> August 19, 2025
          </p>

          <div className="bg-card p-6 rounded-lg border mb-8">
            <p className="text-lg leading-relaxed">
              At TailorWiz, your trust is our top priority. We collect only the information needed to deliver our resume tailoring, job-matching, and career optimization services. We never sell your personal data and we take every measure to keep it safe.
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">What We Collect:</h2>
            <ul className="space-y-2 list-disc pl-6">
              <li>Account information (name, email address, password)</li>
              <li>Uploaded resumes, cover letters, LinkedIn content, and job descriptions</li>
              <li>Interaction data (feature usage, preferences, session history)</li>
              <li>Payment details (processed securely through trusted third-party providers)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">How We Use It:</h2>
            <ul className="space-y-2 list-disc pl-6">
              <li>To process your resume tailoring, analysis, and job qualification requests</li>
              <li>To save and manage your documents in your Resume Library and Job Library</li>
              <li>To send updates, feature tips, and support responses</li>
              <li>To maintain platform security and improve our services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">Security Measures:</h2>
            <ul className="space-y-2 list-disc pl-6">
              <li>Secure encryption for all file uploads and personal data</li>
              <li>Restricted employee access to sensitive data</li>
              <li>Regular audits to ensure compliance with data protection laws</li>
            </ul>
          </section>

          <div className="bg-muted p-6 rounded-lg border">
            <p className="text-lg">
              You have the right to request a copy of your data, correct inaccuracies, or delete your account at any time by contacting{" "}
              <a 
                href="mailto:privacy@tailorwiz.com" 
                className="text-primary underline hover:text-primary/80"
              >
                privacy@tailorwiz.com
              </a>.
            </p>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}